import React, { Component } from "react";
import PropTypes from "prop-types";

// material-ui
import { withStyles } from "@material-ui/core/styles";

// styles
import styles from "./styles";

class Message extends Component {
  static propTypes = {
    title: PropTypes.string,
    classes: PropTypes.object,
  };

  render() {
    const { title, classes } = this.props;

    return <div className={classes.codeheader}>{title}</div>;
  }
}

export default withStyles(styles)(Message);
